import React from 'react';
const platforms = ['MYOB', 'MYOB Exo', 'Stratus', 'LexisNexis', 'FilePro', 'CaseWare', 'Settify', 'Softdocs / Lawdocs'];
export function TrustStrip() {
  return <section className="w-full border-b border-border bg-white py-14 md:py-16" aria-label="Platform familiarity" data-id="element-491">
      <div className="mx-auto max-w-content px-5 md:px-8" data-id="element-492">
        <p className="text-center text-[13px] font-semibold uppercase tracking-[0.12em] text-slate" data-id="element-493">
          Familiar with the systems professional firms rely on
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-2.5 md:gap-3" data-id="element-494">
          {platforms.map(p => <span key={p} className="rounded-full border border-border bg-surface-2 px-5 py-2.5 text-[14px] font-bold text-ink/70 transition-all duration-300 ease-smooth hover:-translate-y-0.5 hover:border-ct-cyan/40 hover:bg-white hover:text-ct-deep hover:shadow-sm" data-id="element-495">
              {p}
            </span>)}
        </div>
      </div>
    </section>;
}